const colorPrinter = function (printer) {
  if (printer.outOfOrder) return 'red';
  if (printer.state) {
    if (printer.state.readyToEdit && printer.state.readyToRead) return 'orange';
    if (printer.state.readyToRead) return 'green';
    return 'red';
  }
  return 'red';
};

export {colorPrinter};
